import React from 'react';

import DestructiveActionButton from '@dashboard/components/destructive-action-triggers/DestructiveActionButton';
import { useCreateWorkflowRunCommandMutation, type WorkflowRunCommandName } from '@dashboard/generated/wp/platform';

type Props = {
  buttonText: string;
  workflowRunId: string;
  commandName: WorkflowRunCommandName;
  title: string;
  description: string;
  confirmButtonLabel?: string;
};

export default function BaseCommandButton({
  buttonText,
  description,
  title,
  workflowRunId,
  commandName,
  confirmButtonLabel,
}: Props) {
  const [createCommand, { loading }] = useCreateWorkflowRunCommandMutation();

  return (
    <DestructiveActionButton
      buttonText={buttonText}
      description={description}
      title={title}
      loading={loading}
      onSubmit={async () => {
        await createCommand({ variables: { workflowRunId, commandName } });
      }}
      confirmButtonLabel={confirmButtonLabel}
    />
  );
}
